import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Avatar, Heading, Modal, Popover, QuillText } from '@treams/treams-ui';

export default function EvaluationNoteModal(props: {
	comment: graphql.CommentFragment;
	onClose: () => void;
}) {
	const { t } = useTranslation();

	return (
		<Popover center visible>
			<Modal>
				<Modal.Header
					title={t('evaluation.submission.notes.title')}
					onClose={() => props.onClose()}
				/>
				<Modal.Contents>
					<Flex flexDirection="row" alignItems="center" mb={3}>
						<Box flexGrow={0} flexShrink={0}>
							<Avatar user={props.comment.user} size={32} />
						</Box>
						<Box flexGrow={1} flexShrink={1} ml={2}>
							<Heading>
								{props.comment.user.firstName} {props.comment.user.lastName}
							</Heading>
						</Box>
					</Flex>
					<QuillText value={props.comment.content} />
				</Modal.Contents>
			</Modal>
		</Popover>
	);
}
